import _get from "lodash/get";
import { combineReducers } from 'redux';
import { attemptProviderMFA, chooseUnavailableProvider, closeYodleeOnboarding, getProviderAccountStatus, getProviderDetails, loginFormFieldChanged, loginToProvider, markYodleeOnboardingAsComplete, mfaFormFieldChanged, requestIdentity, resetYodleeOnboarding, retryYodleeOnboarding, selectProvider, selectProviderAccount, startYodleeOnboarding, updateProviderSearchQuery } from "../../actions";
import { RESET_PLAID_ONBOARDING } from "../../actions/financial-data";
import createFormReducer from "./create-form-reducer";
export var selectedProviderId = function selectedProviderId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  // startYodleeOnboarding may optionally pass a provider id to "preselect"
  if (type === selectProvider.getType()) {
    return _get(payload, 'id');
  }

  if (type === startYodleeOnboarding.getType() && _get(payload, 'providerId')) {
    return _get(payload, 'providerId');
  }

  if (type === closeYodleeOnboarding.getType()) return null;
  if (type === resetYodleeOnboarding.getType()) return null;
  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
};
export var selectedProvider = function selectedProvider() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref2.type,
      payload = _ref2.payload;

  if (type === chooseUnavailableProvider.getType()) {
    // should only be called by the Plaid FDP flow
    return payload;
  }

  return state;
};
export var selectedProviderAccountId = function selectedProviderAccountId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref3.type,
      payload = _ref3.payload;

  if (type === selectProviderAccount.getType()) return payload; // startYodleeOnboarding may optionally pass a provider account id to "preselect"

  if (type === startYodleeOnboarding.getType() && _get(payload, 'providerAccountId')) {
    return payload.providerAccountId;
  }

  if (type === loginToProvider.SUCCESS_TYPE && _get(payload, 'provider_account_id')) {
    return payload.provider_account_id;
  }

  if (type === closeYodleeOnboarding.getType()) return null;
  if (type === resetYodleeOnboarding.getType()) return null;
  if (type === retryYodleeOnboarding.getType()) return null;
  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
};
export var searchQuery = function searchQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref4 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref4.type,
      payload = _ref4.payload;

  if (type === updateProviderSearchQuery.getType()) return payload;
  if (type === closeYodleeOnboarding.getType()) return null;
  if (type === resetYodleeOnboarding.getType()) return null;
  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
}; // Keep track of any async action failures that are related to Yodlee
// onboarding. This state being populate may indicate an error should be shown
// to the user. See related selectors in src/selectors/yodlee.js.

export var lastAsyncError = function lastAsyncError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref5 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref5.type,
      payload = _ref5.payload;

  switch (type) {
    case selectProviderAccount.getType():
    case retryYodleeOnboarding.getType():
    case closeYodleeOnboarding.getType():
    case RESET_PLAID_ONBOARDING:
    case resetYodleeOnboarding.getType():
    case loginToProvider.START_TYPE:
    case attemptProviderMFA.START_TYPE:
      return null;

    case getProviderDetails.FAIL_TYPE:
    case loginToProvider.FAIL_TYPE:
    case attemptProviderMFA.FAIL_TYPE:
    case getProviderAccountStatus.FAIL_TYPE:
    case requestIdentity.FAIL_TYPE:
      return {
        action: type,
        error: payload
      };

    default:
      return state;
  }
}; // whether yodlee onboarding has been marked as complete. Used in the web flow when the user
// select "ok" from the success step. Not used for mobile.

export var isComplete = function isComplete() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref6 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref6.type;

  if (type === markYodleeOnboardingAsComplete.getType()) return true;
  if (type === closeYodleeOnboarding.getType()) return false;
  if (type === resetYodleeOnboarding.getType()) return false;
  if (type === RESET_PLAID_ONBOARDING) return false;
  return state;
}; // provider type for the top 8 providers that are shown on the provider search step.

export var topProviderType = function topProviderType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref7 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref7.type,
      payload = _ref7.payload;

  if (type === startYodleeOnboarding.getType() && _get(payload, 'topProviderType')) {
    return _get(payload, 'topProviderType');
  }

  if (type === closeYodleeOnboarding.getType()) return null;

  if (type === resetYodleeOnboarding.getType() && payload !== true) {
    return null;
  }

  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
}; // skip error screen flag used to go directly to log in / MFA screen(s)

export var shouldSkipErrorScreen = function shouldSkipErrorScreen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref8 = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref8.type,
      payload = _ref8.payload;

  if (type === startYodleeOnboarding.getType() && _get(payload, 'shouldSkipErrorScreen')) {
    return _get(payload, 'shouldSkipErrorScreen');
  }

  if (type === closeYodleeOnboarding.getType()) return null;
  if (type === resetYodleeOnboarding.getType()) return null;
  if (type === RESET_PLAID_ONBOARDING) return null;
  return state;
};
export default combineReducers({
  selectedProviderId: selectedProviderId,
  selectedProviderAccountId: selectedProviderAccountId,
  selectedProvider: selectedProvider,
  lastAsyncError: lastAsyncError,
  searchQuery: searchQuery,
  isComplete: isComplete,
  topProviderType: topProviderType,
  loginForm: createFormReducer(loginFormFieldChanged.getType()),
  mfaForm: createFormReducer(mfaFormFieldChanged.getType()),
  shouldSkipErrorScreen: shouldSkipErrorScreen
});